var customTableSearchTimer;
window.customTableSearch = function(elm){
  clearTimeout(customTableSearchTimer);
  customTableSearchTimer = setTimeout(function () {
    var customSearchVal = $(elm).val()
    console.log(customSearchVal)
    if (customSearchVal.length) {
      customSearchVal = customSearchVal.toUpperCase()
      $(elm).closest(".table-custom-search").find(`[searchable_value]`).attr('hidden', 'hidden')
      var records = $(elm).closest(".table-custom-search").find(`[searchable_value*=${customSearchVal}]`)
      if (records.length) {
        $(elm).closest(".table-custom-search").find(`[searchable_value*=${customSearchVal}]`).removeAttr('hidden', 'hidden')
      }
    } else {
      $(elm).closest(".table-custom-search").find(`[searchable_value]`).removeAttr('hidden', 'hidden')
    }
  }, 250);
}